import React, { createRef, Fragment, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import ProductsContainer from "../Containers/Products.container";
import QuickSearchCompletionContainer from "../Containers/QuickSearchCompletion.Container"
import QuickSearchCompletionItem from "../Components/QuickSearchCompletionItem"
import { translate } from '../Services/translation';
import QuickSearchSuggestions from './QuickSearchSuggestions';

const QuickSearchResult = ({ products = [], blocks, settings, result, showAll, noHit, searchUrl, completionSuggestions, query, nameSuggestions }) => {
    const [blocksAppended, setBlocksAppended] = useState(false);
    const blockContainerRef = createRef();
    useEffect(() => {
        if (blocksAppended || !blockContainerRef || !blockContainerRef.current) return;

        for (var block of blocks) {
            blockContainerRef.current.appendChild(block);
        }

        setBlocksAppended(true);
    }, [blockContainerRef]);

    const onCompletionClick = (name) => {
        window.location.href = window.__litium.quickSearchUrl + (name.length > 0 ? `?q=${name}` : '')
    }
    const itemsToLeft = result ? Object.keys(result) : [];

    return ReactDOM.createPortal(
        <div className="quick-search-result row">
            <ul className="small-12 medium-2 columns quick-search-result__left-section">
                {completionSuggestions.length > 0 && <li className="quick-search-result__item quick-search-Suggestion_group-header" >{translate('global.search.proposal')}</li>}
                {completionSuggestions.length > 0 && completionSuggestions.map(completionSuggestion => <QuickSearchCompletionItem className="quick-search-Suggestion_item quick-search-result__item" completionSuggestion={completionSuggestion} query={query} />)}
                {completionSuggestions.length <= 0 && nameSuggestions.length > 0 && <li className="quick-search-result__item quick-search-Suggestion_group-header" >{translate('global.did.you.mean')}</li>}
                {nameSuggestions.length > 0
                    && completionSuggestions <= 0
                    && nameSuggestions.map(nameSuggestion => <QuickSearchCompletionItem className="quick-search-result__item quick-search-left_menu-Correction_item" completionSuggestion={nameSuggestion} query={query} />)}
                {!noHit && itemsToLeft.map(key => <ul className="quick-search-result__item-group" key={key}>
                    {(Array.isArray(result[key]) && result[key].length) ? <li className="quick-search-result__item quick-search-result__group-header">{result[key][0].category}</li> : ''}
                    {result[key].map(item => <li key={item.name + item.url} className={`quick-search-result__item`} >
                        <a className={`quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'}`}
                            href={item.url}>
                            <div>{item.name}</div>
                        </a>
                    </li>)}
                </ul>)}
                {itemsToLeft.length == 0 && settings.leftSectionLinks.length > 0 && <>
                    {settings.titleLeftSection && <li className="quick-search-result__item quick-search-result__group-header">
                        {settings.titleLeftSection}
                    </li>}
                    {settings.leftSectionLinks.map((link, idx) => <li key={`${link.href}-${idx}`} className="quick-search-result__item">
                        <a className="quick-search-result__link" href={link.href}>{link.text}</a>
                    </li>)}
                </>}
            </ul>
            <div className={`small-12 ${!noHit ? "medium-10" : ""} columns quick-search-result__right-section`}>
                {products && products.length > 0 && <span className="quick-search-result__group-header">{translate('global.products')}</span>}
                {products && products.length > 0 && <ProductsContainer products={products} hide={["quick-add", "wish-list"]} className="no-padding no-margin" productBreakpoints={{ large: 2, "medium-large": 2, medium: 4, small: 6 }} />}
                {!noHit && (!products || products.length == 0) && <>
                    {settings.titleRightSection && <div className="quick-search-result__group-header">{settings.titleRightSection}</div>}
                </>}
                <div className="quick-search-result__block-area-wrapper" ref={blockContainerRef} style={{ display: !noHit && (!products || products.length == 0) ? "block" : "none" }}></div>
                {showAll && <div className="quick-search-result__button-wrapper">
                    <a className="btn btn--primary" href={searchUrl}>{showAll.name}</a>
                </div>}
                {noHit && nameSuggestions.length <= 0 && <div className="quick-search-result__no-hit">
                    <h4>{noHit.name}</h4>
                    <div>{translate("quick-search.no-hit.help-text")}</div>
                </div>}
                {noHit && nameSuggestions.length >= 1 && <div className="quick-search-result__no-hit">
                    <h4>{noHit.name}</h4>
                    <div className="quick-search-NoResult_suggestions__group-header">{translate('global.did.you.mean')}</div>
                    <div className="quick-search_noResult_suggestions.container">
                        <ul className='quick-search-noResult_suggestions'>
                            {nameSuggestions.map(nameSuggestion => <li onClick={() => onCompletionClick(nameSuggestion.text)}>"<b>{nameSuggestion.href ? <a href={nameSuggestion.href}>{nameSuggestion.text}</a> : nameSuggestion.text}</b>"</li>)}
                        </ul>
                    </div>
                </div>}
            </div>
        </div>,
        document.getElementById('searchResult'));
}

export default QuickSearchResult;